export default "__VITE_ASSET__C$xabKNm__"